import { createElementBlock as o, openBlock as t, createElementVNode as l } from "vue";
import n from "./index289.js";
const r = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function a(s, e, f, i, p, m) {
  return t(), o("svg", c, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#E5F2F9",
        d: "M33.4 36.58c1.502 0 5.969-.182 8.972-.182 3.66 0 6.628-2.993 6.628-6.685 0-3.692-2.968-6.685-6.628-6.685C42.372 17.489 37.92 13 32.429 13c-4.37 0-8.071 2.846-9.405 6.799-4.041.556-7.453 4.327-7.453 8.556h9.603A8.226 8.226 0 0 1 33.4 36.58Z"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M32.43 11.9c5.713 0 10.41 4.37 10.983 9.973l.011.127.155.022c3.617.572 6.4 3.67 6.517 7.444l.004.247c0 4.215-3.326 7.65-7.483 7.781l-.245.004H34.5a1.1 1.1 0 0 1-.12-2.193l.12-.007h7.872c3.05 0 5.528-2.499 5.528-5.585s-2.477-5.585-5.528-5.585a1.1 1.1 0 0 1-1.1-1.1c0-4.933-3.96-8.928-8.843-8.928-3.809 0-7.15 2.459-8.363 6.05a1.1 1.1 0 0 1-.892.739 7.206 7.206 0 0 0-6.215 7.153 1.1 1.1 0 0 1-2.2 0 9.409 9.409 0 0 1 7.325-9.19l.128-.027.091-.217c1.685-3.925 5.489-6.585 9.823-6.704l.303-.004Zm-7.003 20.647a1.25 1.25 0 0 1 .127 2.493l-.127.007H13.715a1.25 1.25 0 0 1-.127-2.494l.127-.006h11.712Zm4.93 6.237a1.25 1.25 0 0 1 .129 2.493l-.128.007H10a1.25 1.25 0 0 1-.128-2.494l.128-.006h20.358Zm11.997 6.236a1.25 1.25 0 0 1 .128 2.494l-.128.006H21.996a1.25 1.25 0 0 1-.128-2.493l.128-.007h20.358Z"
      })
    ], -1)
  ]));
}
const _ = /* @__PURE__ */ n(r, [["render", a]]);
export {
  _ as default
};
